/**
 * Created by Raul on 15/04/2018.
 */

export class UserModel {
  id: any;
  project_client_name?: string;
  project_client?: number;
  is_client?: boolean;
  cellphone?: string;
  responsible?: any;
  lote?: string;
  name?: string;
  last_name?: string;
  phone?: number;
  email?: string;
  username?: string;
  password?: string;
  confirm_password?: string
  deadline?: string; // fecha de entrega
}



// WEBPACK FOOTER //
// ./src/app/public/service/user.model.ts